// extracted by mini-css-extract-plugin
export default {"viewAllWrapper":"_3538096","viewAllCta":"_f1a995f3"};